import { ReclamationForm } from "./ReclamationForm.tsx";
import { AsyncFetchRender } from "../../../common/async/AsyncFetchRender.tsx";
import {CustomerOrderApi} from "../../../../api/generated/erp/sales/customerOrder/api/customerOrderApi.ts";

export interface NewCustomerOrderReclamationFormProps {
	customerOrderId: number;
	closeModal: () => void;
}

export const ReclamationFromCustomerOrderForm = ({
	customerOrderId,
	closeModal,
}: NewCustomerOrderReclamationFormProps) => {
	return (
		<AsyncFetchRender
			fetch={() => CustomerOrderApi.getCustomerOrder({ customerOrderId })}
			content={(customerOrder) => (
				<ReclamationForm
					reclamationId={undefined}
					newReclamationDefaultValues={{
						customerOrderId: customerOrder.customerOrderId,
						complainerName: customerOrder.contactName,
						complainerPhone: customerOrder.contactPhone,
						complainerEmail: customerOrder.contactEmail,
						address: {
							address_1: customerOrder.deliveryAddress_1,
							address_2: customerOrder.deliveryAddress_2,
							city: customerOrder.deliveryCity,
							postalCode: customerOrder.deliveryPostalCode,
							country: customerOrder.deliveryCountry,
						},
					}}
					onCompleted={closeModal}
				/>
			)}
		/>
	);
};
